import request from '@/utils/request'

export function doAuth (data) {
  return request({
    url: '/api/v1/auth/url',
    method: 'POST',
    data: data
  })
}

export function doAuth2 (data) {
  return request({
    url: '/api/v1/auth/token',
    method: 'POST',
    data: data
  })
}

export function refreshToken (data) {
  return request({
    url: '/api/v1/auth/refreshtoken',
    method: 'POST',
    data: data
  })
}

export function getUserInfo (data) {
  return request({
    url: '/api/v1/auth/user/info',
    method: 'POST',
    data: data
  })
}
